import { TemplateMode } from '@/interface/point-of-sale';

import type { CartItem } from '../types/cart-item';
import type { MenuSnapshotProduct } from '../types/menu-snapshot';
import { productHasSubselections } from './category-products';

export function shouldOpenProductSheet(product: MenuSnapshotProduct, cartItems: CartItem[]): boolean {
  return productHasSubselections(product);
}
